import Tooltip from '../Tooltip/Tooltip'
import classes from './RunSelectedStepTagBadge.module.scss'

export interface Props {
  label: string
}

const RunSelectedStepTagBadge = ({
  label
}: Props) => (
  <Tooltip label={label}>
    <span
      aria-label={label}
      className={classes.RunSelectedStepTagBadge}
    >
      {label}
    </span>
  </Tooltip>
)

export default RunSelectedStepTagBadge
